export default {
  sockUrl: 'http://localhost:5000',

  initialLiveEventsAdd: [{ id: 1, name: 'first' }],
  eventToBeAdded: { id: 2, name: 'second' },
  expectedLiveEventsAdd: [{ id: 1, name: 'first' }, { id: 2, name: 'second' }],

  initialLiveEventsRemove: [{ id: 1, name: 'first' }, { id: 2, name: 'second' }],
  eventToBeRemoved: { eventId: 2 },
  expectedLiveEventsRemove: [{ id: 1, name: 'first' }],

  messageAdd: `[{
    "mt": 5,
    "leo": {
      "liveEvent": {
        "event": {
          "id": 111111,
          "name": "team 1 vs team 2"
        }
      }
    }
  }]`,
  messageRemove: '[{"mt":18,"er":{"eventId":222222}}]',
  messageToBeIgnored: `[{
    "mt": 4,
    "ea": {
      "event": {
        "id": 555555,
        "name": "team 5 vs team 6"
      }
    }
  }]`,

};
